export default __webpack_public_path__ + "static/media/care2.3a15af3e.jpeg";